import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/play_/$")({
  beforeLoad: ({ params: { _splat: splat }, location }) => {
    const suffix = new URL(location.href, "https://softmax.com").search;
    const segments = (splat ?? "")
      .split("/")
      .filter(Boolean)
      .map(encodeURIComponent);
    const path = segments.length ? `/${segments.join("/")}/play` : "/play";
    throw redirect({ href: `${path}${suffix}`, statusCode: 307 });
  },
});
